import { generateTestId } from "@client-shared";

const base = "LoadingIcon";

export const setLoadingIconTestId = (identifier: string): string => generateTestId(base, identifier);
